import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { UserContext } from './UserContext';
// Import the JSON-based configuration
import appConfig, { ENDPOINT_KEYS } from './config/appConfig';
import './output.css';

// SVG icons as components
const UserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
  </svg>
);

const MailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

const LockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
  </svg>
);

const KeyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
  </svg>
);

const EyeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
  </svg>
);

const EyeOffIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
  </svg>
);

const BuildingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
  </svg>
);

const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
  </svg>
);

const GlobeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
  </svg>
);

const LocationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const LoginAndAuthentication = () => {
  const [view, setView] = useState('login'); // 'login', 'forgot', 'validate-token', 'reset-password', 'create-account'
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const { setUser } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    token: '',
    name: '',
    // Account creation fields
    accountType: 'Individual',
    accountDescription: '',
    companyName: '',
    corporateAddress: '',
    corporatePhoneNumber: '',
    corporateWebsite: '',
    corporateEmail: '',
    industryOrBusinessType: '',
    primaryContactName: '',
    primaryContactEmail: '',
    primaryContactPhone: ''
  });

  const navigate = useNavigate();

  // Clear error and success messages when view changes, and reset form for create-account
  useEffect(() => {
    setError('');
    setSuccess('');

    // Clear form when navigating to create-account view
    if (view === 'create-account') {
      setFormData({
        email: '',
        password: '',
        confirmPassword: '',
        token: '',
        name: '',
        // Account creation fields
        accountType: 'Individual',
        accountDescription: '',
        companyName: '',
        corporateAddress: '',
        corporatePhoneNumber: '',
        corporateWebsite: '',
        corporateEmail: '',
        industryOrBusinessType: '',
        primaryContactName: '',
        primaryContactEmail: '',
        primaryContactPhone: ''
      });
    }
  }, [view]);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
  };

  const validatePassword = (password) => {
    return password.length >= 8 &&
           /[A-Z]/.test(password) &&
           /[a-z]/.test(password) &&
           /[0-9]/.test(password) &&
           /[^A-Za-z0-9]/.test(password);
  };

  const validatePhoneNumber = (phone) => {
    // Basic phone validation - adjust as needed
    return /^\d{3}-\d{3}-\d{4}$/.test(phone) || /^\(\d{3}\)\s?\d{3}-\d{4}$/.test(phone) || /^\d{10}$/.test(phone);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Auto-generate account description based on name and account type
    const getAccountDescription = (accountType, userName, companyName) => {
      if (accountType === 'Individual' && userName.trim()) {
        return `${userName.trim()}'s Personal Account`;
      } else if (accountType === 'Corporate' && companyName.trim()) {
        return companyName.trim();
      }
      return formData.accountDescription;
    };

    let updatedFormData = { ...formData, [name]: value };

    // Auto-update account description when name changes (for Individual)
    if (name === 'name' && formData.accountType === 'Individual') {
      updatedFormData.accountDescription = getAccountDescription('Individual', value, '');
    }

    // Auto-update primary contact name when user name changes (for Corporate)
    if (name === 'name' && formData.accountType === 'Corporate') {
      updatedFormData.primaryContactName = value;
    }

    // Auto-update primary contact email when user email changes (for Corporate)
    if (name === 'email' && formData.accountType === 'Corporate') {
      updatedFormData.primaryContactEmail = value;
    }

    // Auto-update account description when company name changes (for Corporate)
    if (name === 'companyName' && formData.accountType === 'Corporate') {
      updatedFormData.accountDescription = getAccountDescription('Corporate', '', value);
    }

    // Clear corporate fields when switching from Corporate to Individual
    if (name === 'accountType' && value === 'Individual') {
      updatedFormData = {
        ...updatedFormData,
        companyName: '',
        corporateAddress: '',
        corporatePhoneNumber: '',
        corporateWebsite: '',
        corporateEmail: '',
        industryOrBusinessType: '',
        primaryContactName: '',
        primaryContactEmail: '',
        primaryContactPhone: ''
      };
      // Update account description for Individual type
      if (formData.name.trim()) {
        updatedFormData.accountDescription = getAccountDescription('Individual', formData.name, '');
      } else {
        updatedFormData.accountDescription = '';
      }
    }

    // Update account description and prefill primary contact when switching to Corporate type
    if (name === 'accountType' && value === 'Corporate') {
      updatedFormData.accountDescription = '';
      // Prefill primary contact with user info
      updatedFormData.primaryContactName = formData.name;
      updatedFormData.primaryContactEmail = formData.email;
    }

    setFormData(updatedFormData);
    setError('');
    setSuccess('');
  };

  const checkExistingAuth = async () => {
    const token = localStorage.getItem('authToken');
    const userId = localStorage.getItem('user_id');

    if (!token || !userId) {
      return false;
    }

    try {
      // Verify the token is still valid by making a test API call
      const response = await fetch(appConfig.getUrl('/get_account_list'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          user_id: userId
        }),
      });

      if (response.ok) {
        const data = await response.json();
        return data.status === 'Success';
      }
      return false;
    } catch (error) {
      console.error('Auth check failed:', error);
      return false;
    }
  };

  useEffect(() => {
    const checkAuth = async () => {
      setIsLoading(true);
      const isAuthenticated = await checkExistingAuth();

      if (isAuthenticated) {
        // User is already logged in, redirect to home page
        navigate('/RequirementsPortal');
      }
      setIsLoading(false);
    };

    checkAuth();
  }, [navigate]);

  const createAccountAndUser = async (accountData) => {
    try {
      const requestBody = formData.accountType === 'Corporate' ? {
        account_description: accountData.accountDescription,
        account_type: accountData.accountType,
        company_name: accountData.companyName,
        corporate_address: accountData.corporateAddress,
        corporate_phone_number: accountData.corporatePhoneNumber,
        corporate_website: accountData.corporateWebsite,
        corporate_email: accountData.corporateEmail,
        industry_or_business_type: accountData.industryOrBusinessType,
        primary_contact_name: accountData.primaryContactName,
        primary_contact_email: accountData.primaryContactEmail,
        primary_contact_phone: accountData.primaryContactPhone,
        user_id: accountData.email,
        user_name: accountData.name,
        password: accountData.password,
        access_level: 9
      } : {
        account_description: accountData.accountDescription,
        account_type: accountData.accountType,
        user_id: accountData.email,
        user_name: accountData.name,
        password: accountData.password,
        access_level: 9
      };

      const response = await fetch(appConfig.getUrl('/create_account_and_user'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (data.status !== 'Success') {
        throw new Error(data.status_description || 'Account and user creation failed');
      }

      return data;
    } catch (err) {
      throw new Error(err.message || 'Account and user creation failed');
    }
  };

  const loginUser = async (email, password) => {
    try {
      const response = await fetch(appConfig.getUrl('/validate_user_credentials'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: email,
          password: password
        }),
      });

      const data = await response.json();

      if (data.status !== 'Success') {
        throw new Error(data.status_description || 'Login failed');
      }

      // Store the token in localStorage
      localStorage.setItem('authToken', data.login_token);
      localStorage.setItem('user_id', data.user_id);
      localStorage.setItem('user_name', data.user_name);
      localStorage.setItem('user_since', data.user_since);
      localStorage.setItem('corporate_account', data.corporate_account);
      localStorage.setItem('default_project', data.default_project);

      // get account tied to the user.
      const response2 = await fetch(appConfig.getUrl('/get_account_list'), {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${data.login_token}`
        },
        body: JSON.stringify({
          user_id: data.user_id
        }),
      });

      const data2 = await response2.json();

      if (data2.status !== 'Success') {
        throw new Error(data.status_description || 'Login failed');
      }
      localStorage.setItem('account_description', data2.account_list[0].account_description);

      return data;
    } catch (err) {
      throw new Error(err.message || 'Login failed');
    }
  };

  const resetPassword = async (email) => {
    try {
      const response = await fetch(appConfig.getUrl('/generate_password_reset_token'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: email
        }),
      });

      const data = await response.json();

      if (data.status !== 'Success') {
        throw new Error(data.status_description || 'Password reset failed');
      }

      return data;
    } catch (err) {
      throw new Error(err.message || 'Password reset failed');
    }
  };

  const validatePasswordResetToken = async (email, token) => {
    try {
      const response = await fetch(appConfig.getUrl('/validate_password_reset_token'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: email,
          token: token
        }),
      });

      const data = await response.json();

      // Log the response for debugging
      console.log('Token validation response:', data);

      if (data.status !== 'Success') {
        throw new Error(data.status_description || 'Token validation failed');
      }

      return data;
    } catch (err) {
      console.error('Token validation error:', err);
      throw new Error(err.message || 'Token validation failed');
    }
  };

  const updatePassword = async (email, newPassword) => {
    try {
      // For password reset, we need a different endpoint since the existing one requires authentication
      // You'll need to create a new endpoint like '/reset_user_password' that doesn't require auth
      // but validates the reset flow. For now, I'll show the structure needed:

      const response = await fetch(appConfig.getUrl('/reset_user_password'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: email,
          new_password: newPassword
        }),
      });

      const data = await response.json();

      if (data.status !== 'Success') {
        throw new Error(data.status_description || 'Password update failed');
      }

      return data;
    } catch (err) {
      throw new Error(err.message || 'Password update failed');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsLoading(true);

    try {
      switch(view) {
        case 'login':
          if (!validateEmail(formData.email)) {
            throw new Error('Please enter a valid email address');
          }
          const loginResponse = await loginUser(formData.email, formData.password);
          setSuccess(`Welcome back, ${loginResponse.user_name}!`);
          navigate('/RequirementsPortal');
          break;

        case 'create-account':
          // Validate required fields
          if (!formData.name.trim()) {
            throw new Error('Please enter your full name');
          }
          if (!validateEmail(formData.email)) {
            throw new Error('Please enter a valid email address');
          }
          if (!validatePassword(formData.password)) {
            throw new Error('Password must be at least 8 characters long and contain uppercase, lowercase, number, and special character');
          }
          if (formData.password !== formData.confirmPassword) {
            throw new Error('Passwords do not match');
          }
          if (!formData.accountDescription.trim()) {
            throw new Error('Please enter an account description');
          }

          // Validate corporate fields if corporate account
          if (formData.accountType === 'Corporate') {
            if (!formData.companyName.trim()) {
              throw new Error('Please enter company name');
            }
            if (!formData.corporateAddress.trim()) {
              throw new Error('Please enter corporate address');
            }
            if (!formData.corporatePhoneNumber.trim()) {
              throw new Error('Please enter corporate phone number');
            }
            if (!formData.corporateEmail.trim() || !validateEmail(formData.corporateEmail)) {
              throw new Error('Please enter a valid corporate email');
            }
            if (!formData.industryOrBusinessType.trim()) {
              throw new Error('Please enter industry or business type');
            }
            if (!formData.primaryContactName.trim()) {
              throw new Error('Please enter primary contact name');
            }
            if (!formData.primaryContactEmail.trim() || !validateEmail(formData.primaryContactEmail)) {
              throw new Error('Please enter a valid primary contact email');
            }
            if (!formData.primaryContactPhone.trim()) {
              throw new Error('Please enter primary contact phone');
            }
          }

          // Create account and user in single transaction
          const createResponse = await createAccountAndUser(formData);

          setSuccess('Account and user created successfully! You will be redirected to login.');
          setTimeout(() => {
            setView('login');
            setSuccess('');
            // Clear all form data after successful creation
            setFormData({
              email: '',
              password: '',
              confirmPassword: '',
              token: '',
              name: '',
              accountType: 'Individual',
              accountDescription: '',
              companyName: '',
              corporateAddress: '',
              corporatePhoneNumber: '',
              corporateWebsite: '',
              corporateEmail: '',
              industryOrBusinessType: '',
              primaryContactName: '',
              primaryContactEmail: '',
              primaryContactPhone: ''
            });
          }, 5000);
          break;

        case 'forgot':
          if (!validateEmail(formData.email)) {
            throw new Error('Please enter a valid email address');
          }
          await resetPassword(formData.email);
          setSuccess('A password reset token has been sent to your email! It will expire in 10 minutes.');
          setTimeout(() => {
            setView('validate-token');
            setSuccess('');
          }, 5000);
          break;

        case 'validate-token':
          if (!formData.token.trim()) {
            throw new Error('Please enter the reset token');
          }
          if (!validateEmail(formData.email)) {
            throw new Error('Please enter a valid email address');
          }
          await validatePasswordResetToken(formData.email, formData.token);
          setSuccess('Token validated successfully! Please set your new password.');
          setTimeout(() => {
            setView('reset-password');
            setSuccess('');
          }, 5000);
          break;

        case 'reset-password':
          if (!validatePassword(formData.password)) {
            throw new Error('Password must be at least 8 characters long and contain uppercase, lowercase, number, and special character');
          }
          if (formData.password !== formData.confirmPassword) {
            throw new Error('Passwords do not match');
          }
          await updatePassword(formData.email, formData.password);
          setSuccess('Password updated successfully! You will be redirected to login.');
          setTimeout(() => {
            setView('login');
            setSuccess('');
            setFormData({
              email: formData.email,
              password: '',
              confirmPassword: '',
              token: '',
              name: ''
            });
          }, 5000);
          break;
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getViewTitle = () => {
    switch(view) {
      case 'login': return 'Login';
      case 'create-account': return 'Create New Account';
      case 'forgot': return 'Reset Password';
      case 'validate-token': return 'Enter Reset Token';
      case 'reset-password': return 'Set New Password';
      default: return 'Login';
    }
  };

  const getSubmitButtonText = () => {
    switch(view) {
      case 'login': return 'Login';
      case 'create-account': return 'Create Account';
      case 'forgot': return 'Generate Password Reset Code';
      case 'validate-token': return 'Validate Token';
      case 'reset-password': return 'Update Password';
      default: return 'Submit';
    }
  };

  if (isLoading && view === 'login') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="flex items-center justify-center">
          <svg className="animate-spin h-8 w-8 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span className="ml-2 text-gray-600">Checking authentication...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="w-full max-w-2xl bg-white rounded-lg shadow-md overflow-hidden">
        <div className="p-6">
          {/* Logo Section */}
          <div className="flex justify-center mb-2">
            <img
              src="/logos/logo-reqsharp-blue.svg"
              alt="ReqSharp Logo"
              className="h-20 w-auto"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>

          <div className="text-m text-center text-blue-800 mb-4 block bg-purple-100 rounded p-2">
            <div>Capture, Track & Succeed</div>
            <div><b>Requirements Management Simplified</b></div>
          </div>

          <h2 className="text-2xl font-bold text-center mb-6">
            {getViewTitle()}
          </h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Create Account Fields */}
            {view === 'create-account' && (
              <>
                {/* User Information */}
                <div className="space-y-4 border-b pb-4">
                  <h3 className="text-lg font-medium text-gray-900">User Information</h3>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">Full Name *</label>
                    <div className="relative">
                      <div className="absolute left-3 top-2.5">
                        <UserIcon />
                      </div>
                      <input
                        type="text"
                        name="name"
                        placeholder="John Doe"
                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={formData.name}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">Email *</label>
                    <div className="relative">
                      <div className="absolute left-3 top-2.5">
                        <MailIcon />
                      </div>
                      <input
                        type="email"
                        name="email"
                        autoComplete="email"
                        placeholder="you@example.com"
                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">Password *</label>
                    <div className="relative">
                      <div className="absolute left-3 top-2.5">
                        <LockIcon />
                      </div>
                      <input
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        autoComplete="new-password"
                        placeholder="••••••••"
                        className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={formData.password}
                        onChange={handleInputChange}
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-3 top-2.5"
                      >
                        {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                      </button>
                    </div>
                    <p className="text-xs text-gray-500">
                      Password must be at least 8 characters with uppercase, lowercase, number, and special character.
                    </p>
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">Confirm Password *</label>
                    <div className="relative">
                      <div className="absolute left-3 top-2.5">
                        <LockIcon />
                      </div>
                      <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        name="confirmPassword"
                        autoComplete="new-password"
                        placeholder="••••••••"
                        className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                      />
                      <button
                        type="button"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        className="absolute right-3 top-2.5"
                      >
                        {showConfirmPassword ? <EyeOffIcon /> : <EyeIcon />}
                      </button>
                    </div>
                  </div>
                </div>

                {/* Account Information */}
                <div className="space-y-4 border-b pb-4">
                  <h3 className="text-lg font-medium text-gray-900">Account Information</h3>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">Account Type *</label>
                    <select
                      name="accountType"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={formData.accountType}
                      onChange={handleInputChange}
                    >
                      <option value="Individual">Individual</option>
                      <option value="Corporate">Corporate</option>
                    </select>
                  </div>
                </div>

                {/* Corporate Information - Only shown for Corporate accounts */}
                {formData.accountType === 'Corporate' && (
                  <div className="space-y-4">
                    <h3 className="text-lg font-medium text-gray-900">Corporate Information</h3>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">Company Name *</label>
                        <div className="relative">
                          <div className="absolute left-3 top-2.5">
                            <BuildingIcon />
                          </div>
                          <input
                            type="text"
                            name="companyName"
                            placeholder="Acme Corporation"
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={formData.companyName}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">Corporate Email *</label>
                        <div className="relative">
                          <div className="absolute left-3 top-2.5">
                            <MailIcon />
                          </div>
                          <input
                            type="email"
                            name="corporateEmail"
                            placeholder="info@company.com"
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={formData.corporateEmail}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">Corporate Phone *</label>
                        <div className="relative">
                          <div className="absolute left-3 top-2.5">
                            <PhoneIcon />
                          </div>
                          <input
                            type="tel"
                            name="corporatePhoneNumber"
                            placeholder="555-123-4567"
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={formData.corporatePhoneNumber}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">Corporate Website</label>
                        <div className="relative">
                          <div className="absolute left-3 top-2.5">
                            <GlobeIcon />
                          </div>
                          <input
                            type="text"
                            name="corporateWebsite"
                            placeholder="www.company.com"
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={formData.corporateWebsite}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700">Corporate Address *</label>
                      <div className="relative">
                        <div className="absolute left-3 top-2.5">
                          <LocationIcon />
                        </div>
                        <input
                          type="text"
                          name="corporateAddress"
                          placeholder="123 Main St, City, State 12345"
                          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          value={formData.corporateAddress}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700">Industry or Business Type *</label>
                      <input
                        type="text"
                        name="industryOrBusinessType"
                        placeholder="Technology Services"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={formData.industryOrBusinessType}
                        onChange={handleInputChange}
                      />
                    </div>

                    <h4 className="text-md font-medium text-gray-900 pt-4">Primary Contact Information</h4>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">Primary Contact Name *</label>
                        <div className="relative">
                          <div className="absolute left-3 top-2.5">
                            <UserIcon />
                          </div>
                          <input
                            type="text"
                            name="primaryContactName"
                            placeholder="John Smith"
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={formData.primaryContactName}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">Primary Contact Email *</label>
                        <div className="relative">
                          <div className="absolute left-3 top-2.5">
                            <MailIcon />
                          </div>
                          <input
                            type="email"
                            name="primaryContactEmail"
                            placeholder="john.smith@company.com"
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={formData.primaryContactEmail}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="space-y-2 md:col-span-2">
                        <label className="block text-sm font-medium text-gray-700">Primary Contact Phone *</label>
                        <div className="relative">
                          <div className="absolute left-3 top-2.5">
                            <PhoneIcon />
                          </div>
                          <input
                            type="tel"
                            name="primaryContactPhone"
                            placeholder="555-987-6543"
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={formData.primaryContactPhone}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Account Description - Moved to bottom */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">Account Description *</label>
                  <input
                    type="text"
                    name="accountDescription"
                    placeholder={formData.accountType === 'Individual' ? "John Doe's Personal Account" : "Company Name"}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={formData.accountDescription}
                    onChange={handleInputChange}
                  />
                  <p className="text-xs text-gray-500">
                    {formData.accountType === 'Individual'
                      ? "This will be auto-filled based on your name"
                      : "This will be auto-filled based on your company name"}
                  </p>
                </div>
              </>
            )}

            {/* Email field - shown in login, forgot, validate-token, and reset-password views */}
            {['login', 'forgot', 'validate-token', 'reset-password'].includes(view) && (
              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">Email</label>
                <div className="relative">
                  <div className="absolute left-3 top-2.5">
                    <MailIcon />
                  </div>
                  <input
                    type="email"
                    name="email"
                    autoComplete="email"
                    placeholder="you@example.com"
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={formData.email}
                    onChange={handleInputChange}
                    disabled={view === 'reset-password'} // Disable editing in final step
                  />
                </div>
              </div>
            )}

            {/* Password field - shown in login view only */}
            {view === 'login' && (
              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">Password</label>
                <div className="relative">
                  <div className="absolute left-3 top-2.5">
                    <LockIcon />
                  </div>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    autoComplete="current-password"
                    placeholder="••••••••"
                    className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={formData.password}
                    onChange={handleInputChange}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-2.5"
                  >
                    {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                  </button>
                </div>
              </div>
            )}

            {/* Token field - shown in validate-token view */}
            {view === 'validate-token' && (
              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">Reset Token</label>
                <div className="relative">
                  <div className="absolute left-3 top-2.5">
                    <KeyIcon />
                  </div>
                  <input
                    type="text"
                    name="token"
                    placeholder="Enter the token from your email"
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={formData.token}
                    onChange={handleInputChange}
                  />
                </div>
                <p className="text-xs text-gray-500">
                  Check your email for the reset token. It expires in 10 minutes.
                </p>
              </div>
            )}

            {/* New password fields - shown in reset-password view */}
            {view === 'reset-password' && (
              <>
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">New Password</label>
                  <div className="relative">
                    <div className="absolute left-3 top-2.5">
                      <LockIcon />
                    </div>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      autoComplete="new-password"
                      placeholder="••••••••"
                      className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={formData.password}
                      onChange={handleInputChange}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-2.5"
                    >
                      {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                    </button>
                  </div>
                  <p className="text-xs text-gray-500">
                    Password must be at least 8 characters with uppercase, lowercase, number, and special character.
                  </p>
                </div>

                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">Confirm New Password</label>
                  <div className="relative">
                    <div className="absolute left-3 top-2.5">
                      <LockIcon />
                    </div>
                    <input
                      type={showConfirmPassword ? 'text' : 'password'}
                      name="confirmPassword"
                      autoComplete="new-password"
                      placeholder="••••••••"
                      className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={formData.confirmPassword}
                      onChange={handleInputChange}
                    />
                    <button
                      type="button"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      className="absolute right-3 top-2.5"
                    >
                      {showConfirmPassword ? <EyeOffIcon /> : <EyeIcon />}
                    </button>
                  </div>
                </div>
              </>
            )}

            {error && (
              <div className="p-4 bg-red-50 border border-red-200 rounded-md">
                <p className="text-sm text-red-600">{error}</p>
              </div>
            )}

            {success && (
              <div className="p-4 bg-green-50 border border-green-200 rounded-md">
                <p className="text-sm text-green-600">{success}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-blue-800 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Processing...
                </span>
              ) : (
                getSubmitButtonText()
              )}
            </button>

            <div className="flex flex-col space-y-2 text-sm text-center">
              {view === 'login' && (
                <>
                  <button
                    type="button"
                    onClick={() => setView('forgot')}
                    className="text-blue-600 hover:underline"
                  >
                    Forgot password?
                  </button>
                  <button
                    type="button"
                    onClick={() => setView('create-account')}
                    className="text-blue-600 hover:underline"
                  >
                    Create new account
                  </button>
                </>
              )}
              {view === 'create-account' && (
                <button
                  type="button"
                  onClick={() => setView('login')}
                  className="text-blue-600 hover:underline"
                >
                  Already have an account? Login
                </button>
              )}
              {view === 'forgot' && (
                <button
                  type="button"
                  onClick={() => setView('login')}
                  className="text-blue-600 hover:underline"
                >
                  Back to login
                </button>
              )}
              {view === 'validate-token' && (
                <div className="flex flex-col space-y-2">
                  <button
                    type="button"
                    onClick={() => setView('forgot')}
                    className="text-blue-600 hover:underline"
                  >
                    Resend reset token
                  </button>
                  <button
                    type="button"
                    onClick={() => setView('login')}
                    className="text-gray-600 hover:underline"
                  >
                    Back to login
                  </button>
                </div>
              )}
              {view === 'reset-password' && (
                <button
                  type="button"
                  onClick={() => setView('login')}
                  className="text-blue-600 hover:underline"
                >
                  Back to login
                </button>
              )}
            </div>
          </form>


          {/* Website Link - Added at bottom of all views */}
            <div className="mt-6 text-center border-t pt-4">
              <a
                href="https://www.reqsharp.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
              >
                www.reqsharp.com
              </a>
            </div>

            <div className="mt-0 text-center pt-4">
              <a
                href="https://www.reqsharp.com/feedback"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
              >
                Contact us
              </a>
            </div>

        </div>
      </div>
    </div>
  );
};

export default LoginAndAuthentication;